import { render, staticRenderFns } from "./TourRType.vue?vue&type=template&id=4000af23&scoped=true"
import script from "./TourRType.vue?vue&type=script&lang=js"
export * from "./TourRType.vue?vue&type=script&lang=js"
import style0 from "./TourRType.vue?vue&type=style&index=0&id=4000af23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000af23",
  null
  
)

export default component.exports